import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapState } from "vuex";
import DripCampaignClientsModal from "../modals/drip-campaign-clients-modal";
import DripCampaignDeleteModal from "../modals/drip-campaign-delete-modal";
import { EXPORT_STATISTICS, TOGGLE_CURRENT_CAMPAIGN_ACTIVE } from "../../store/drip-campaign-actions";
import ButtonBar from "@Shared/components/general/button-bar";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import PlanTooltip from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-tooltip.vue";
import { LOAD_PLAN_LIMIT } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import { IS_USAGE_RESTRICTED } from "@Broker/@Modules/account-plan/store/account-plan-getters";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignEditHeader",
  components: {
    DripCampaignDeleteModal,
    DripCampaignClientsModal,
    ButtonBar,
    SimpleButton,
    PlanTooltip,
    ProfileAvatar
  },
  props: {
    name: {
      type: String,
      required: true
    },
    campaignId: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    isValid: {
      type: Boolean,
      required: true
    },
    loadingSaving: {
      type: Boolean,
      required: true
    },
    emailVerified: {
      type: Boolean,
      required: true
    },
    createdBy: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      togglingActive: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AccountPlanStore", ["currentPagePlan"])), mapGetters("AccountPlanStore", [IS_USAGE_RESTRICTED])), {}, {
    isActivated: {
      get() {
        return this.active;
      },
      set() {
        this.toggleActive();
      }
    },
    disabledSwitch() {
      return this.IS_USAGE_RESTRICTED(this.currentPagePlan) && !this.isActivated && !this.togglingActive;
    },
    backLink() {
      return {
        name: "marketing-list"
      };
    },
    disabledTooltipText() {
      return this.active ? this.$t("drip-campaigns.messages.disabledTooltipText") : "";
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [EXPORT_STATISTICS, TOGGLE_CURRENT_CAMPAIGN_ACTIVE])), mapActions("AccountPlanStore", [LOAD_PLAN_LIMIT])), {}, {
    showClientsModal() {
      this.$refs.clientsModal.showModal();
    },
    handleShowDeleteModal() {
      if (this.isActivated) return;
      this.$refs.deleteModal.showModal();
    },
    handleExportStatistics() {
      this.EXPORT_STATISTICS(this.campaignId);
    },
    handleSaveChanges() {
      this.$emit("save-changes");
    },
    async toggleActive() {
      this.togglingActive = true;
      await this.TOGGLE_CURRENT_CAMPAIGN_ACTIVE();
      this.LOAD_PLAN_LIMIT(this.currentPagePlan);
      this.togglingActive = false;
    }
  })
});